<template>
  <div>
    <b-card no-body>
      <b-tabs card>
        <!-- SEKME 1: CANLI TEST ÇALIŞTIRICI -->
        <b-tab title="Test Motoru" active>
          
          <!-- Üst Kontrol Kartı -->
          <b-row class="align-items-center mb-1">
            <b-col md="6">
              <h4 class="mb-50 font-weight-bolder">Sistem Doğrulama & İzolasyon Test Motoru</h4>
              <p class="mb-0 text-muted small">
                Backend router, kimlik doğrulama, sipariş ve IDOR izolasyon adımlarını modüler çalıştırın.
              </p>
            </b-col>
            <b-col md="6" class="text-md-right mt-1 mt-md-0">
              <b-button
                v-b-toggle.auth-panel-collapse
                variant="outline-info"
                class="mr-50"
                size="sm"
              >
                <feather-icon icon="KeyIcon" class="mr-25" />
                Giriş & Token Paneli
              </b-button>
              <b-button
                variant="outline-secondary"
                class="mr-50"
                size="sm"
                :disabled="isRunning"
                @click="fetchActiveSteps"
              >
                <feather-icon icon="RefreshCwIcon" class="mr-25" />
                Yenile
              </b-button>
              <b-button
                variant="primary"
                size="sm"
                class="px-2"
                :disabled="isRunning || loadingSteps || filteredSteps.length === 0"
                @click="runSelectedGroup"
              >
                <b-spinner v-if="isRunning" small class="mr-50" />
                <feather-icon v-else icon="PlayIcon" class="mr-50" />
                {{ isRunning ? 'Testler Koşuluyor...' : (selectedPhase === 'ALL' ? 'Tüm Testleri Koş' : `${selectedPhase} Fazını Koş`) }}
              </b-button>
            </b-col>
          </b-row>

          <!-- KATLANABİLİR KİMLİK & TOKEN GİRİŞ PANELİ -->
          <b-collapse id="auth-panel-collapse" class="mb-2">
            <b-card bg-variant="light" border-variant="primary" class="mb-0">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <h6 class="mb-0 font-weight-bold text-primary">
                  <feather-icon icon="ShieldIcon" class="mr-50" />
                  Test Kullanıcıları ve Oturum Token Havuzu
                </h6>
                <b-button
                  size="sm"
                  variant="primary"
                  :disabled="isRunning || isLoggingIn"
                  @click="loginAll"
                >
                  <b-spinner v-if="isLoggingIn" small class="mr-25" />
                  <feather-icon v-else icon="LogInIcon" class="mr-25" />
                  Tüm Girişleri Yap & Tokenları Al
                </b-button>
              </div>

              <b-row>
                <!-- Admin / Developer -->
                <b-col md="4" class="mb-1">
                  <b-card class="h-100 shadow-none border mb-0 p-50">
                    <div class="d-flex justify-content-between align-items-center mb-50">
                      <strong class="text-dark small">Admin</strong>
                      <b-button size="xs" variant="outline-primary" @click="loginAccount('admin')">Giriş Yap</b-button>
                    </div>
                    <b-form-group label="E-Posta" label-size="sm" class="mb-50">
                      <b-form-input v-model="accounts.admin.email" size="sm" placeholder="admin@domain.com" />
                    </b-form-group>
                    <b-form-group label="Şifre" label-size="sm" class="mb-50">
                      <b-form-input v-model="accounts.admin.password" size="sm" type="password" placeholder="••••••" />
                    </b-form-group>
                    <b-form-group label="Bearer Token" label-size="sm" class="mb-0">
                      <b-form-input v-model="accounts.admin.token" size="sm" class="font-monospace small" placeholder="Token" />
                    </b-form-group>
                  </b-card>
                </b-col>

                <!-- Fenomen A -->
                <b-col md="4" class="mb-1">
                  <b-card class="h-100 shadow-none border mb-0 p-50">
                    <div class="d-flex justify-content-between align-items-center mb-50">
                      <strong class="text-warning small">Fenomen A (Birincil)</strong>
                      <b-button size="xs" variant="outline-warning" @click="loginAccount('fenomenA')">Giriş Yap</b-button>
                    </div>
                    <b-form-group label="E-Posta" label-size="sm" class="mb-50">
                      <b-form-input v-model="accounts.fenomenA.email" size="sm" placeholder="ramazana@fenoman.com" />
                    </b-form-group>
                    <b-form-group label="Şifre" label-size="sm" class="mb-50">
                      <b-form-input v-model="accounts.fenomenA.password" size="sm" type="password" placeholder="1594567" />
                    </b-form-group>
                    <b-form-group label="Token & Local ID" label-size="sm" class="mb-0">
                      <b-input-group size="sm">
                        <b-form-input v-model="accounts.fenomenA.token" class="font-monospace small" placeholder="Bearer Token" />
                        <b-input-group-append>
                          <b-form-input v-model="accounts.fenomenA.id" placeholder="ID" style="max-width: 65px;" title="Local DB ID" />
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-card>
                </b-col>

                <!-- Fenomen B -->
                <b-col md="4" class="mb-1">
                  <b-card class="h-100 shadow-none border mb-0 p-50">
                    <div class="d-flex justify-content-between align-items-center mb-50">
                      <strong class="text-success small">Fenomen B (İzolasyon Rakibi)</strong>
                      <b-button size="xs" variant="outline-success" @click="loginAccount('fenomenB')">Giriş Yap</b-button>
                    </div>
                    <b-form-group label="E-Posta" label-size="sm" class="mb-50">
                      <b-form-input v-model="accounts.fenomenB.email" size="sm" placeholder="fenomenb@test.com" />
                    </b-form-group>
                    <b-form-group label="Şifre" label-size="sm" class="mb-50">
                      <b-form-input v-model="accounts.fenomenB.password" size="sm" type="password" placeholder="••••••" />
                    </b-form-group>
                    <b-form-group label="Token & Local ID" label-size="sm" class="mb-0">
                      <b-input-group size="sm">
                        <b-form-input v-model="accounts.fenomenB.token" class="font-monospace small" placeholder="Bearer Token" />
                        <b-input-group-append>
                          <b-form-input v-model="accounts.fenomenB.id" placeholder="ID" style="max-width: 65px;" title="Local DB ID" />
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-card>
                </b-col>
              </b-row>
            </b-card>
          </b-collapse>

          <!-- MODÜL / FAZ SEÇİM BUTONLARI -->
          <div class="d-flex align-items-center flex-wrap gap-1 mb-1 p-50 bg-light rounded border">
            <span class="font-weight-bold text-muted small mr-1">Grup Filtresi:</span>
            <b-button
              size="sm"
              :variant="selectedPhase === 'ALL' ? 'primary' : 'outline-secondary'"
              class="mr-50 mb-25"
              @click="selectedPhase = 'ALL'"
            >
              Tümü ({{ steps.length }})
            </b-button>
            <b-button
              v-for="phase in uniquePhases"
              :key="phase"
              size="sm"
              :variant="selectedPhase === phase ? 'primary' : 'outline-secondary'"
              class="mr-50 mb-25"
              @click="selectedPhase = phase"
            >
              {{ phase }} ({{ steps.filter(s => s.phase === phase).length }})
            </b-button>
          </div>

          <!-- İlerleme Çubuğu -->
          <div v-if="filteredTotalSteps > 0" class="mb-2">
            <div class="d-flex justify-content-between mb-50">
              <small class="font-weight-bold">
                İlerleme: {{ filteredCompletedSteps }} / {{ filteredTotalSteps }} Adım Tamamlandı
              </small>
              <small class="font-weight-bold" :class="filteredFailedStepsCount > 0 ? 'text-danger' : 'text-success'">
                {{ filteredFailedStepsCount > 0 ? `${filteredFailedStepsCount} Hata Var` : 'Tümü Başarılı' }}
              </small>
            </div>
            <b-progress
              :value="filteredProgressPercentage"
              :variant="filteredFailedStepsCount > 0 ? 'danger' : 'success'"
              striped
              :animated="isRunning"
              height="10px"
            />
          </div>

          <!-- Yükleniyor / Boş Durumlar -->
          <div v-if="loadingSteps" class="text-center py-4">
            <b-spinner variant="primary" />
            <p class="mt-1 text-muted">Test adımları yükleniyor...</p>
          </div>

          <div v-else-if="filteredSteps.length === 0" class="text-center py-4 text-muted">
            <feather-icon icon="AlertCircleIcon" size="28" class="mb-50 d-block mx-auto" />
            Seçili fazda aktif test adımı bulunamadı.
          </div>

          <!-- Test Adımları Tablosu -->
          <div v-else class="test-steps-timeline">
            <div
              v-for="(step, index) in filteredSteps"
              :key="step.id || step.step_code"
              class="test-step-item p-1 mb-1 rounded border"
              :class="getStepBorderClass(step.status)"
            >
              <b-row class="align-items-center">
                <!-- Sol: Kod, Başlık & Endpoint -->
                <b-col md="6" class="d-flex align-items-center">
                  <b-avatar
                    :variant="getStepAvatarVariant(step.status)"
                    size="34"
                    class="mr-1 font-weight-bold flex-shrink-0"
                  >
                    {{ index + 1 }}
                  </b-avatar>
                  <div>
                    <div class="d-flex align-items-center flex-wrap">
                      <span class="font-weight-bolder mr-50">{{ step.step_code }}</span>
                      <b-badge v-if="step.is_critical" variant="light-danger" pill class="mr-50">KRİTİK</b-badge>
                      <b-badge variant="light-secondary" pill class="mr-50 font-monospace">{{ step.method }} {{ step.endpoint }}</b-badge>
                      <b-badge variant="light-primary" pill>{{ step.phase }}</b-badge>
                    </div>
                    <div class="font-weight-bold text-dark mt-25">{{ step.title }}</div>
                    <small class="text-muted d-block">{{ step.description }}</small>
                  </div>
                </b-col>

                <!-- Orta: HTTP Kodları -->
                <b-col md="3" class="text-md-center mt-50 mt-md-0">
                  <small class="d-block text-muted">
                    Beklenen Kod: <strong>{{ step.expected_http_code }}</strong>
                  </small>
                  <small v-if="step.executedHttpCode !== null" class="d-block">
                    Dönen Kod:
                    <strong :class="step.executedHttpCode === step.expected_http_code ? 'text-success' : 'text-danger'">
                      {{ step.executedHttpCode }}
                    </strong>
                  </small>
                  <small v-if="step.duration" class="text-muted">{{ step.duration }} ms</small>
                </b-col>

                <!-- Sağ: Durum ve Eylemler -->
                <b-col md="3" class="text-md-right mt-50 mt-md-0">
                  <b-badge :variant="getBadgeVariant(step.status)" class="p-50">
                    <feather-icon :icon="getStatusIcon(step.status)" class="mr-25" />
                    {{ getStatusLabel(step.status) }}
                  </b-badge>
                  <div v-if="step.errorMessage" class="text-danger small mt-25 text-break">
                    {{ step.errorMessage }}
                  </div>
                  <div class="mt-25">
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      :disabled="isRunning"
                      @click="executeStep(step)"
                    >
                      {{ step.status === 'failed' ? 'Tekrar Dene' : 'Çalıştır' }}
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-tab>

        <!-- SEKME 2: GEÇMİŞ TEST KOŞULARI -->
        <b-tab title="Geçmiş Koşular" @click="fetchRuns">
          <div class="d-flex justify-content-between align-items-center mb-1">
            <h5 class="mb-0">Kaydedilen Test Raporları</h5>
            <b-button size="sm" variant="outline-primary" :disabled="loadingRuns" @click="fetchRuns">
              <feather-icon icon="RefreshCwIcon" class="mr-25" />
              Tazele
            </b-button>
          </div>

          <div v-if="loadingRuns" class="text-center py-3">
            <b-spinner variant="primary" small />
            <span class="ml-50 text-muted">Raporlar yükleniyor...</span>
          </div>

          <b-table
            v-else
            responsive
            striped
            hover
            :items="runs"
            :fields="runFields"
            show-empty
            empty-text="Henüz kaydedilmiş test koşusu bulunmuyor."
          >
            <template #cell(status)="data">
              <b-badge :variant="data.item.status === 'passed' ? 'light-success' : (data.item.status === 'failed' ? 'light-danger' : 'light-warning')">
                {{ data.item.status === 'passed' ? 'BAŞARILI' : (data.item.status === 'failed' ? 'HATALI' : 'DEVAM EDİYOR') }}
              </b-badge>
            </template>
            <template #cell(steps)="data">
              <span class="text-success font-weight-bold">{{ data.item.passed_steps }} Geçti</span> /
              <span class="text-danger font-weight-bold">{{ data.item.failed_steps }} Kaldı</span>
              <small class="text-muted"> (Toplam: {{ data.item.total_steps }})</small>
            </template>
            <template #cell(duration_ms)="data">
              {{ (data.item.duration_ms / 1000).toFixed(2) }} sn
            </template>
            <template #cell(actions)="data">
              <b-button size="sm" variant="outline-primary" @click="showRunDetail(data.item)">
                Detayları Gör
              </b-button>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>

    <!-- Geçmiş Detay Modalı -->
    <b-modal
      v-model="detailModal"
      title="Test Koşusu Detayı"
      size="lg"
      hide-footer
    >
      <div v-if="selectedRun">
        <div class="d-flex justify-content-between align-items-center mb-1 pb-50 border-bottom">
          <div>
            <strong>Tarih:</strong> {{ selectedRun.created_at }} |
            <strong>Müşteri SK:</strong> <code>{{ selectedRun.customer_sk }}</code>
          </div>
          <div>
            <b-badge :variant="selectedRun.status === 'passed' ? 'light-success' : 'light-danger'">
              {{ selectedRun.status.toUpperCase() }}
            </b-badge>
          </div>
        </div>

        <div class="test-detail-list">
          <div
            v-for="(res, idx) in selectedRun.results"
            :key="idx"
            class="p-1 mb-50 rounded border d-flex justify-content-between align-items-center"
            :class="res.status === 'passed' ? 'border-success bg-light-success' : 'border-danger bg-light-danger'"
          >
            <div>
              <span class="font-weight-bold mr-50">{{ res.code }}</span>
              <span>{{ res.title }}</span>
              <div v-if="res.error" class="text-danger small mt-25">
                Hata: {{ res.error }}
              </div>
            </div>
            <div class="text-right">
              <b-badge :variant="res.status === 'passed' ? 'success' : 'danger'">
                HTTP {{ res.http_code !== null ? res.http_code : 'N/A' }}
              </b-badge>
              <small class="d-block text-muted">{{ res.duration }} ms</small>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BBadge, BProgress, BSpinner, BAvatar,
  BTabs, BTab, BTable, BModal, BCollapse, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, VBToggle
} from 'bootstrap-vue'

export default {
  components: {
    BCard, BRow, BCol, BButton, BBadge, BProgress, BSpinner, BAvatar,
    BTabs, BTab, BTable, BModal, BCollapse, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend
  },
  directives: {
    'b-toggle': VBToggle
  },
  data() {
    return {
      isRunning: false,
      isLoggingIn: false,
      loadingSteps: false,
      steps: [],
      selectedPhase: 'ALL',
      currentRunId: null,
      runStartTime: null,

      // Geçmiş Tablosu
      runs: [],
      loadingRuns: false,
      detailModal: false,
      selectedRun: null,
      runFields: [
        { key: 'id', label: '#' },
        { key: 'customer_sk', label: 'Müşteri SK' },
        { key: 'status', label: 'Durum' },
        { key: 'steps', label: 'Adım Dağılımı' },
        { key: 'duration_ms', label: 'Süre' },
        { key: 'created_at', label: 'Tarih' },
        { key: 'actions', label: 'İşlem', class: 'text-right' }
      ],

      // Tekilleştirilmiş Hesap Havuzu (Giriş & Test senaryoları aynı objeyi kullanır)
      accounts: {
        admin: {
          username: `test_admin_${Date.now()}`,
          password: 'TestPassword123!',
          email: `admin_${Date.now()}@example.com`,
          name_surname: 'Test Admin User',
          user_type: 'admin',
          token: '',
          id: null,
          verificationToken: null
        },
        fenomenA: {
          username: `fenomen_a_${Date.now()}`,
          password: 'TestPassword123!',
          email: `fenomen_a_${Date.now()}@example.com`,
          name_surname: 'Fenomen A Test',
          user_type: 'influencer',
          token: '',
          id: null,
          verificationToken: null
        },
        fenomenB: {
          username: `fenomen_b_${Date.now()}`,
          password: 'TestPassword123!',
          email: `fenomen_b_${Date.now()}@example.com`,
          name_surname: 'Fenomen B Test',
          user_type: 'influencer',
          token: '',
          id: null,
          verificationToken: null
        }
      },

      // Dinamik Test Değerleri
      sharedData: {
        fenomenALinkId: null,
        fenomenASecretKey: 'SB1eokQglp',
        fenomenBLinkId: null,
        fenomenBSecretKey: null,
        lastTransactionId: null
      },

      fakeCustomerSk: 'SHOPIFY_TEST'
    }
  },
  computed: {
    uniquePhases() {
      return [...new Set(this.steps.map(s => s.phase))].filter(Boolean)
    },
    filteredSteps() {
      if (this.selectedPhase === 'ALL') return this.steps
      return this.steps.filter(s => s.phase === this.selectedPhase)
    },
    filteredTotalSteps() {
      return this.filteredSteps.length
    },
    filteredCompletedSteps() {
      return this.filteredSteps.filter(s => s.status === 'passed' || s.status === 'failed').length
    },
    filteredFailedStepsCount() {
      return this.filteredSteps.filter(s => s.status === 'failed').length
    },
    filteredProgressPercentage() {
      if (this.filteredTotalSteps === 0) return 0
      return Math.round((this.filteredCompletedSteps / this.filteredTotalSteps) * 100)
    }
  },
  created() {
    this.fetchActiveSteps()
    this.fetchRuns()
  },
  methods: {
    async fetchActiveSteps() {
      this.loadingSteps = true
      try {
        const response = await this.$http.get('/manage/test-steps')
        if (response.data && response.data.success) {
          this.steps = response.data.data
            .filter(s => s.is_active)
            .map(s => ({
              ...s,
              status: 'pending',
              executedHttpCode: null,
              duration: null,
              errorMessage: null
            }))
        }
      } catch (error) {
        this.$bvToast.toast('Test adımları yüklenirken hata oluştu.', {
          title: 'Hata',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.loadingSteps = false
      }
    },

    async fetchRuns() {
      this.loadingRuns = true
      try {
        const res = await this.$http.get('/manage/test-runs?limit=15')
        if (res.data && res.data.success) {
          this.runs = res.data.data
        }
      } catch (err) {
        console.error('Test geçmişi alınamadı:', err)
      } finally {
        this.loadingRuns = false
      }
    },

    showRunDetail(run) {
      this.selectedRun = run
      this.detailModal = true
    },

    // Tekil Kullanıcı Oturumu Açma (/auth/login)
    async loginAccount(type) {
      const acc = this.accounts[type]
      if (!acc || !acc.email || !acc.password) {
        this.$bvToast.toast('E-posta ve şifre zorunludur.', { variant: 'warning', solid: true })
        return
      }

      try {
        const res = await this.$http.post('/auth/login', {
          email: acc.email,
          password: acc.password,
          user_type: acc.user_type
        })

        const token = res.data.token || res.data.data?.token || res.data.access_token
        const userId = res.data.userData?.id || res.data.data?.userData?.id || res.data.userData?.local_id

        if (token) {
          acc.token = token
          if (userId) acc.id = userId
          this.$bvToast.toast(`${type.toUpperCase()} girişi başarılı. Token alındı.`, { variant: 'success', solid: true })
        } else {
          throw new Error('Token dönmedi')
        }
      } catch (err) {
        const msg = err.response?.data?.message || err.response?.data?.error || err.message
        this.$bvToast.toast(`${type.toUpperCase()} hatası: ${msg}`, { variant: 'danger', solid: true })
      }
    },

    async loginAll() {
      this.isLoggingIn = true
      try {
        await this.loginAccount('admin')
        await this.loginAccount('fenomenA')
        await this.loginAccount('fenomenB')
      } finally {
        this.isLoggingIn = false
      }
    },

    async runSelectedGroup() {
      if (this.isRunning) return
      this.isRunning = true
      this.runStartTime = Date.now()

      this.filteredSteps.forEach(s => {
        s.status = 'pending'
        s.executedHttpCode = null
        s.duration = null
        s.errorMessage = null
      })

      try {
        const currentCustomerSk = this.$store.state.user?.customerInfo?.secret_key || ''
        const startRes = await this.$http.post('/manage/test-runs/start', {
          customer_sk: currentCustomerSk,
          phase: this.selectedPhase
        })
        this.currentRunId = startRes.data?.run_id || null

        for (const step of this.filteredSteps) {
          await this.executeStep(step)
        }
      } catch (err) {
        console.error('Test akış hatası:', err)
      } finally {
        await this.completeRun()
        this.isRunning = false
      }
    },

    // Backend Controller ve Router ile Birebir Eşleşen Test Koşucusu
    async executeStep(step) {
      step.status = 'running'
      step.errorMessage = null
      const start = Date.now()

      try {
        let response = null
        const currentSK = this.$store.state.user?.customerInfo?.secret_key || ''

        switch (step.step_code) {
          // ==========================================
          // FAZ 1: AUTH & TOKEN
          // ==========================================
          case 'T1.1': // Admin Hesabı Açma
            response = await this.$http.post('/user', {
              name_surname: 'Test Admin',
              email: this.accounts.admin.email,
              phone: '5551112233',
              role: 1,
              user_type: 'admin'
            })
            if (response.data?.token) this.accounts.admin.verificationToken = response.data.token
            break

          case 'T1.2': // Fenomen A Hesabı Açma
            response = await this.$http.post('/user', {
              name_surname: 'Fenomen A',
              email: this.accounts.fenomenA.email,
              phone: '5552223344',
              username: this.accounts.fenomenA.username,
              user_type: 'influencer',
              link_ici_odeme_orani: 10,
              link_disi_odeme_orani: 5
            })
            if (response.data?.token) this.accounts.fenomenA.verificationToken = response.data.token
            break

          case 'T1.3': // Fenomen B Hesabı Açma
            response = await this.$http.post('/user', {
              name_surname: 'Fenomen B',
              email: this.accounts.fenomenB.email,
              phone: '5553334455',
              username: this.accounts.fenomenB.username,
              user_type: 'influencer',
              link_ici_odeme_orani: 10,
              link_disi_odeme_orani: 5
            })
            if (response.data?.token) this.accounts.fenomenB.verificationToken = response.data.token
            break

          case 'T1.4': // Admin Şifre Belirleme
            response = await this.$http.post('/auth/verifyPassword', {
              token: this.accounts.admin.verificationToken || 'dummy_token',
              email: this.accounts.admin.email,
              password: this.accounts.admin.password,
              type: 'verify',
              user_type: 'admin'
            })
            break

          case 'T1.5': // Fenomen A Şifre Belirleme
            response = await this.$http.post('/auth/verifyPassword', {
              token: this.accounts.fenomenA.verificationToken || 'dummy_token',
              email: this.accounts.fenomenA.email,
              password: this.accounts.fenomenA.password,
              type: 'verify',
              user_type: 'influencer'
            })
            break

          case 'T1.6': // Fenomen B Şifre Belirleme
            response = await this.$http.post('/auth/verifyPassword', {
              token: this.accounts.fenomenB.verificationToken || 'dummy_token',
              email: this.accounts.fenomenB.email,
              password: this.accounts.fenomenB.password,
              type: 'verify',
              user_type: 'influencer'
            })
            break

          case 'T1.7': // Admin Login
            response = await this.$http.post('/auth/login', {
              email: this.accounts.admin.email,
              password: this.accounts.admin.password,
              user_type: 'admin'
            })
            break

          case 'T1.8': // Fenomen A Login
            response = await this.$http.post('/auth/login', {
              email: this.accounts.fenomenA.email,
              password: this.accounts.fenomenA.password,
              user_type: 'influencer'
            })
            break

          case 'T1.9': // Fenomen B Login
            response = await this.$http.post('/auth/login', {
              email: this.accounts.fenomenB.email,
              password: this.accounts.fenomenB.password,
              user_type: 'influencer'
            })
            break

          case 'T1.10': // Geçersiz Token (401 Beklenir)
            response = await this.$http.get('/cart', {
              headers: { Authorization: 'Bearer gecersiz_jwt_token_denemesi' },
              skipAuthRedirect: true
            })
            break

          // ==========================================
          // FAZ 2: ROLLER & YETKİ SINIRLARI (RBAC)
          // ==========================================
          case 'T2.1': // Fenomen Link Ekleyemez (403 Beklenir)
            response = await this.$http.post('/link', {
              inf_ids: [this.accounts.fenomenA.id || 1],
              link: 'https://dijitalnet-isortagi.1ticaret.com/test'
            }, {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T2.2': // Fenomen Admin Exportuna Erişemez (403 Beklenir)
            response = await this.$http.get('/download/allLinksRaportExcel', {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T2.3': // Fenomen E-posta Değiştiremez (403 Beklenir)
            response = await this.$http.post('/auth/change-email', {
              user_id: this.accounts.fenomenA.id || 1,
              old_email: this.accounts.fenomenA.email,
              new_email: 'hacked@domain.com',
              user_type: 'influencer'
            }, {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          // ==========================================
          // FAZ 3: KULLANICI YÖNETİMİ (`UserController`)
          // ==========================================
          case 'T3.1': // Admin Kullanıcı Listeleme (GET /user)
            response = await this.$http.get('/user?user_type=influencer', {
              headers: { Authorization: `Bearer ${this.accounts.admin.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T3.2': // Fenomen Kullanıcı Listeleme Engeli (403 Beklenir)
            response = await this.$http.get('/user?user_type=admin', {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T3.3': // Ulanyjy maglumatlaryny täzelemek (PUT /user)
            // 1. Admin profilini täzeleýäris
            response = await this.$http.put('/user', {
              id: this.accounts.admin.id || 1,
              name_surname: 'Admin Updated',
              phone: '5550000000',
              user_type: 'admin'
            }, {
              headers: { Authorization: `Bearer ${this.accounts.admin.token}` },
              skipAuthRedirect: true
            });

            // 2. token_invalid_before täzeleneni üçin admini täzeden login edip täze token alýarys:
            if (response && (response.status === 200 || response.data?.success)) {
              const loginRes = await this.$http.post('/auth/login', {
                email: this.accounts.admin.email,
                password: this.accounts.admin.password,
                user_type: 'admin'
              });

              const refreshedToken = loginRes.data?.token || loginRes.data?.data?.token || loginRes.data?.access_token;
              if (refreshedToken) {
                this.accounts.admin.token = refreshedToken;
              } else {
                throw new Error('Admin maglumatlary täzelendi, ýöne täze Bearer token alyp bolmady.');
              }
            }
            break;

          // ==========================================
          // FAZ 4: LİNK, EVENT & SEPET
          // ==========================================
          case 'T4.1': // Admin -> Fenomen A için Link Açar
            response = await this.$http.post('/link', {
              inf_ids: [this.accounts.fenomenA.id || 1],
              link: 'https://dijitalnet-isortagi.1ticaret.com/kitap',
              campaign_name: 'Fenomen A Kampanyasi',
              type: 0,
              platform_id: 1,
              page_type: 'Kategori',
              category_id: [214],
              description: 'Oto Test Linki'
            }, {
              headers: { Authorization: `Bearer ${this.accounts.admin.token}` },
              skipAuthRedirect: true
            })
            if (response.data?.data) {
              this.sharedData.fenomenALinkId = response.data.data.id
              this.sharedData.fenomenASecretKey = response.data.data.secret_key
            }
            break

          case 'T4.2': // Admin -> Fenomen B için Link Açar
            response = await this.$http.post('/link', {
              inf_ids: [this.accounts.fenomenB.id || 2],
              link: 'https://dijitalnet-isortagi.1ticaret.com/elektronik',
              campaign_name: 'Fenomen B Kampanyasi',
              type: 0,
              platform_id: 1,
              page_type: 'Kategori',
              category_id: [212],
              description: 'Oto Test Linki B'
            }, {
              headers: { Authorization: `Bearer ${this.accounts.admin.token}` },
              skipAuthRedirect: true
            })
            if (response.data?.data) {
              this.sharedData.fenomenBLinkId = response.data.data.id
              this.sharedData.fenomenBSecretKey = response.data.data.secret_key
            }
            break

          case 'T4.3': // Ziyaretçi Tıklaması (POST /eventNew)
            response = await this.$http.post('/eventNew', {
              campaign_secret_key: this.sharedData.fenomenASecretKey || 'iPQXc3Aef8s',
              page_url: window.location.href,
              platform: 'tsoft'
            })
            break

          case 'T4.4': // Sepete Ürün Ekleme (POST /cart)
            response = await this.$http.post('/cart', {
              event_type: 'cart_add',
              campaign_secret_key: this.sharedData.fenomenASecretKey || 'iPQXc3Aef8s',
              product_id: '787',
              product_name: "Burt's Bees Lip Balm Pomegranate",
              category_ids: '245',
              varyant: '',
              quantity: 1,
              total_amount: 90.00,
              browser_info: navigator.userAgent,
              screen_width: window.innerWidth || 1536,
              page_url: window.location.href,
              url: 'burts-bees-lip-balm-pomegranate'
            })
            break


          // ==========================================
          // FAZ 5: İZOLASYON & IDOR KONTROLLERİ
          // ==========================================
          case 'T5.1': // Fenomen A Boş Parametre Sepet İzolasyonu (200 Beklenir)
            response = await this.$http.get('/cart', {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.2': // IDOR ile Sepet Çekme Girişimi (403 Beklenir)
            response = await this.$http.get(`/cart?infId=${this.accounts.fenomenB.id || 9999}`, {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.3': // Fenomen A Link Listesi İzolasyonu (200 Beklenir)
            response = await this.$http.get('/link', {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.4': // Fenomen A Sipariş Listesi İzolasyonu (200 Beklenir)
            response = await this.$http.get('/order', {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.5': // IDOR ile Sipariş Listeleme Girişimi (403 Beklenir)
            response = await this.$http.get(`/order?infId=${this.accounts.fenomenB.id || 9999}`, {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.6': // Fenomen A Ziyaret/Event İzolasyonu (200 Beklenir)
            response = await this.$http.get('/eventNew', {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.7': // IDOR ile Ziyaret Çekme Girişimi (403 Beklenir)
            response = await this.$http.get(`/eventNew?infId=${this.accounts.fenomenB.id || 9999}`, {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.8': // Fenomen A Hakediş Özeti İzolasyonu (200 Beklenir)
            response = await this.$http.get('/order/getVestingSummary', {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.9': // IDOR ile Hakediş Çekme Girişimi (403 Beklenir)
            response = await this.$http.get(`/order/getVestingSummary?infId=${this.accounts.fenomenB.id || 9999}`, {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.10': // IDOR Dashboard SummaryData Girişimi (403 Beklenir)
            response = await this.$http.get(`/analysis/summaryData?infId=${this.accounts.fenomenB.id || 9999}`, {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.11': // IDOR Link Analizi Girişimi (403 Beklenir)
            response = await this.$http.get(`/analysis/links?infId=${this.accounts.fenomenB.id || 9999}`, {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.12': // IDOR Ürün Analizi Girişimi (403 Beklenir)
            response = await this.$http.get(`/analysis/product?infId=${this.accounts.fenomenB.id || 9999}`, {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          case 'T5.13': // Excel Rapor İzolasyonu (200 Beklenir)
            response = await this.$http.get('/download/linkExcel?start_date=2020-01-01&end_date=2030-01-01', {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          // ==========================================
          // FAZ 6: SİPARİŞ & SATIN ALMA (`OrderController::addSpeed`)
          // ==========================================
          case 'T6.1': // Sipariş Tamamlama
            this.sharedData.lastTransactionId = 'TRX-' + Date.now()
            response = await this.$http.post('/order', {
              campaign_secret_key: this.sharedData.fenomenASecretKey || 'SB1eokQglps',
              transaction: this.sharedData.lastTransactionId,
              amount: 90.00,
              cargo_price: 0.00,
              currency: 'TL',
              city: 'İstanbul',
              browser_info: navigator.userAgent,
              products: [
                {
                  identifier: '787',
                  name: "Burt's Bees Lip Balm",
                  total_amount: 90.00,
                  quantity: 1,
                  url: 'burts-bees-lip-balm-pomegranate',
                  code: 'burts-bees-lip-balm-pomegranate'
                }
              ]
            })
            break

          case 'T6.2': // Idempotency: Aynı transaction ile tekrar gönderim
            response = await this.$http.post('/order', {
              campaign_secret_key: this.sharedData.fenomenASecretKey || 'iPQXc3Aef8s',
              transaction: this.sharedData.lastTransactionId,
              amount: 90.00,
              currency: 'TL',
              products: [
                {
                  identifier: '787',
                  name: "Burt's Bees Lip Balm",
                  total_amount: 90.00,
                  quantity: 1,
                  code: 'burts-bees-lip-balm-pomegranate'
                }
              ]
            })
            break

          case 'T6.3': // Fenomen Sipariş Listesi İzolasyonu (GET /order)
            response = await this.$http.get('/order', {
              headers: { Authorization: `Bearer ${this.accounts.fenomenA.token}` },
              skipAuthRedirect: true
            })
            break

          // ==========================================
          // FAZ 7: DIŞ ENTEGRASYON & WEBHOOKLAR
          // ==========================================
          case 'T7.1': // Shopify Webhook Güncelleme
            response = await this.$http.post(`/order/shopify-update-webhook?sk=${currentSK}`, {
              id: this.sharedData.lastTransactionId || 'ORD-TEST-1',
              financial_status: 'paid',
              fulfillment_status: 'fulfilled'
            })
            break

          case 'T7.2': // İade Durum Webhook Testi
            response = await this.$http.post(`/order/shopify-update-webhook?sk=${currentSK}`, {
              id: this.sharedData.lastTransactionId || 'ORD-TEST-1',
              financial_status: 'refunded',
              fulfillment_status: 'unfulfilled'
            })
            break

          // ==========================================
          // FAZ 8: CRON & ARKA PLAN GÖREVLERİ
          // ==========================================
          case 'T8.1':
          case 'T8.2':
          case 'T8.3':
          case 'T8.4':
          case 'T8.5':
          case 'T8.6':
          case 'T8.7':
          case 'T8.8':
          case 'T8.9':
          case 'T8.10':
          case 'T8.11': {
            const cleanEndpoint = step.endpoint.split('?')[0];

            // 1. DENEME: Tamamen yetkisiz ve anahtarsız çağrı (401 Beklenir)
            let res1 = null;
            try {
              res1 = await this.$http.get(cleanEndpoint, {
                headers: { Authorization:'Bearer ' + 'sallama', 'Customer-SK': '' },
                skipAuthRedirect: true
              });
            } catch (e) {
              res1 = e.response;
            }
            if (!res1 || res1.status !== 401) {
              throw new Error(`Açık Var! Keysiz çağrıda 401 yerine HTTP ${res1?.status || 'N/A'} döndü.`);
            }

            // 2. DENEME: Sahte / Yanlış cron_key ile çağrı (403 Beklenir)
            let res2 = null;
            try {
              res2 = await this.$http.get(`${cleanEndpoint}?cron_key=SAHTE_CRON_KEY_SALDIRISI_999`, {
                headers: { Authorization:'Bearer ' + 'sallama', 'Customer-SK': '' },
                skipAuthRedirect: true
              });
            } catch (e) {
              res2 = e.response;
            }
            if (!res2 || res2.status !== 403) {
              throw new Error(`Açık Var! Sahte cron_key ile 403 yerine HTTP ${res2?.status || 'N/A'} döndü.`);
            }

            // 3. DENEME: Fenomen kullanıcısı yetkisiz olarak rotayı tetiklerse (403 Beklenir)
            if (this.accounts.fenomenA.token) {
              let res3 = null;
              try {
                res3 = await this.$http.get(cleanEndpoint, {
                  headers: {
                    Authorization: `Bearer ${this.accounts.fenomenA.token}`,
                    'Customer-SK': ''
                  },
                  skipAuthRedirect: true
                });
              } catch (e) {
                res3 = e.response;
              }
              if (!res3 || res3.status !== 403) {
                throw new Error(`Açık Var! Fenomen rolü ile cron rotasında 403 yerine HTTP ${res3?.status || 'N/A'} döndü.`);
              }
            }
            

            // Üç negatif deneme de başarıyla engellendiyse test başarılıdır
            response = { status: 401 };
            break;
          }

          // ==========================================
          // FAZ 9: GÜVENLİK & MULTI-TENANT TESTLERİ
          // ==========================================
          case 'T9.1': { // 11 Haneli Sahte Key Sepet Reddi
            response = await this.$http.post('/cart', {
              event_type: 'cart_add',
              campaign_secret_key: '98765432101',
              product_id: '787',
              product_name: "Test Urunu",
              category_ids: '245',
              quantity: 1,
              total_amount: 90.00,
              browser_info: navigator.userAgent,
              screen_width: window.innerWidth || 1536,
              page_url: window.location.href,
              url: 'test-urun'
            }, { skipAuthRedirect: true });

            if (response.data?.error !== 'Kampanya bulunamadı') {
              throw new Error(`Güvenlik Açığı: Sahte key ile sepet işleme alındı! Dönen: ${JSON.stringify(response.data)}`);
            }
            break;
          }

          case 'T9.2': { // Link Alanı XSS Sanitization
            response = await this.$http.post('/link', {
              inf_ids: [this.accounts.fenomenA.id || 1],
              link: 'https://dijitalnet-isortagi.1ticaret.com/kitap',
              campaign_name: '<script>alert("xss")<' + '/script>Test Kampanyasi',
              type: 0,
              platform_id: 1,
              page_type: 'Kategori',
              category_id: [214],
              description: 'XSS Sanitization Test'
            }, {
              headers: { Authorization: `Bearer ${this.accounts.admin.token}` },
              skipAuthRedirect: true
            });
            break;
          }

          case 'T9.3': { // Admin Farklı Firma Customer-SK İhlali (403 Beklenir)
            response = await this.$http.get('/user?user_type=influencer', {
              headers: {
                Authorization: `Bearer ${this.accounts.admin.token}`,
                'Customer-SK': this.fakeCustomerSk
              },
              skipAuthRedirect: true
            });
            break;
          }

          case 'T9.4': { // Fenomen Farklı Firma Customer-SK İhlali (403 Beklenir)
            response = await this.$http.get('/cart', {
              headers: {
                Authorization: `Bearer ${this.accounts.fenomenA.token}`,
                'Customer-SK': this.fakeCustomerSk
              },
              skipAuthRedirect: true
            });
            break;
          }

          case 'T9.5': { // Sahte Doğrulama Tokenı ile Şifre Belirleme
            response = await this.$http.post('/auth/verifyPassword', {
              email: this.accounts.admin.email,
              token: 'sahte_veya_rastgele_uretilen_token_12345',
              password: 'NewPassword123!',
              type: 'verify',
              user_type: 'admin'
            }, { skipAuthRedirect: true });

            const resData = response.data || {};
            if (resData.success === true) {
              throw new Error('Güvenlik Açığı: Sahte token ile şifre belirlenebildi!');
            }
            break;
          }

          case 'T9.6': { // Admin Yanlış Şifre ile Login Denemesi
            response = await this.$http.post('/auth/login', {
              email: this.accounts.admin.email,
              password: 'TamamenYanlisSifre!999',
              user_type: 'admin'
            }, { skipAuthRedirect: true });

            const resData = response.data || {};
            if (resData.token || resData.success === true) {
              throw new Error('Güvenlik Açığı: Yanlış şifre ile admin girişi yapıldı ve token üretildi!');
            }
            break;
          }

          case 'T9.7': { // Fenomen Yanlış Şifre ile Login Denemesi
            response = await this.$http.post('/auth/login', {
              email: this.accounts.fenomenA.email,
              password: 'TamamenYanlisSifre!999',
              user_type: 'influencer'
            }, { skipAuthRedirect: true });

            const resData = response.data || {};
            if (resData.token || resData.success === true) {
              throw new Error('Güvenlik Açığı: Yanlış şifre ile fenomen girişi yapıldı ve token üretildi!');
            }
            break;
          }

          case 'T9.8': { // Çapraz Rol Girişimi (Fenomen maili ile admin girişi)
            response = await this.$http.post('/auth/login', {
              email: this.accounts.fenomenA.email, // Fenomen hesabı
              password: this.accounts.fenomenA.password,
              user_type: 'admin' // Admin olarak giriş yapmayı deniyor
            }, { skipAuthRedirect: true });

            const resData = response.data || {};
            if (resData.token || resData.success === true) {
              throw new Error('Yetki Aşımı Açığı: Fenomen hesabı admin tablosu üzerinden giriş yapabildi!');
            }
            break;
          }

          case 'T9.9': { // İmzası Bozulmuş (Manipüle Edilmiş) JWT Token (401 Beklenir)
            // Mevcut geçerli admin token'ının imza kısmını (son 5 karakterini) bozuyoruz
            const validToken = this.accounts.admin.token || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.e30.dummySignature';
            const tamperedToken = validToken.slice(0, -5) + 'XXXXX';

            response = await this.$http.get('/cart', {
              headers: {
                Authorization: `Bearer ${tamperedToken}`
              },
              skipAuthRedirect: true
            });
            break;
          }

          default:
            response = await this.$http({
              method: step.method,
              url: step.endpoint,
              headers: step.role_required === 'admin'
                ? { Authorization: `Bearer ${this.accounts.admin.token}` }
                : step.role_required === 'influencer'
                ? { Authorization: `Bearer ${this.accounts.fenomenA.token}` }
                : {}
            })
            break
        }

        step.executedHttpCode = response ? response.status : 200
        step.duration = Date.now() - start

        const resData = response?.data || {}
        let logicError = null

        // Token Yakalama
        if (['T1.7', 'T1.8', 'T1.9'].includes(step.step_code)) {
          const token = resData.token || resData.data?.token || resData.access_token
          const userId = resData.userData?.id || resData.data?.userData?.id || resData.userData?.local_id
          if (!token) {
            logicError = 'Giriş başarılı döndü ancak Bearer token bulunamadı.'
          } else {
            if (step.step_code === 'T1.7') {
              this.accounts.admin.token = token
              if (userId) this.accounts.admin.id = userId
            }
            if (step.step_code === 'T1.8') {
              this.accounts.fenomenA.token = token
              if (userId) this.accounts.fenomenA.id = userId
            }
            if (step.step_code === 'T1.9') {
              this.accounts.fenomenB.token = token
              if (userId) this.accounts.fenomenB.id = userId
            }
          }
        }
        const targetBId = this.accounts.fenomenB.id
        const targetBLinkId = this.sharedData.fenomenBLinkId
        
        // 1. T5.1 Sepet Sızıntı Denetimi
        if (step.step_code === 'T5.1') {
          const carts = resData.data?.Carts || resData.data || []
          if (targetBId && carts.some(c => (c.influencer?.id || c.inf_id) === targetBId)) {
            logicError = 'Kritik Sızıntı: Parametresiz /cart sorgusunda Fenomen B verisi yer alıyor!'
          }
        }
        // 2. T5.3 Link Sızıntı Denetimi
        else if (step.step_code === 'T5.3') {
          const links = resData.data?.Links || resData.data || []
          if (targetBLinkId && links.some(l => l.id === targetBLinkId)) {
            logicError = 'İzolasyon Açığı: Fenomen A listesinde Fenomen B linki saptandı!'
          }
        }
        // 3. T5.4 Sipariş Sızıntı Denetimi
        else if (step.step_code === 'T5.4') {
          const orders = resData.data?.Orders || resData.data || []
          if (targetBId && orders.some(o => (o.influencer?.id || o.inf_id) === targetBId)) {
            logicError = 'Kritik Sızıntı: Fenomen A sipariş listesinde Fenomen B siparişi bulundu!'
          }
        }
        // 4. T5.6 Ziyaret / Event Sızıntı Denetimi
        else if (step.step_code === 'T5.6') {
          const events = resData.data?.Events || resData.data || []
          if (targetBId && events.some(e => (e.influencer?.id || e.influencer_id || e.inf_id) === targetBId)) {
            logicError = 'İzolasyon Açığı: Fenomen A tıklama/ziyaret dökümünde Fenomen B verisi yer alıyor!'
          }
        }
        // 5. T5.8 Hakediş Sızıntı Denetimi
        else if (step.step_code === 'T5.8') {
          const vestings = Array.isArray(resData.data) ? resData.data : (resData.data?.Vesting || [])
          if (targetBId && vestings.some(v => v.id === targetBId || v.influencer_id === targetBId)) {
            logicError = 'Finansal Sızıntı: Fenomen A hakediş özetinde Fenomen B kazançları yer alıyor!'
          }
        }
        // 6. T5.13 Excel Raporu Sızıntı Denetimi
        else if (step.step_code === 'T5.13') {
          const reportLinks = resData.links || resData.data || []
          if (targetBLinkId && reportLinks.some(r => r.link_id === targetBLinkId || r.id === targetBLinkId)) {
            logicError = 'Rapor Sızıntısı: İndirilen excel verisinde Fenomen B linki bulundu!'
          }
        }

        // executeStep içindeki resData.error denetim satırı:
        const negativeTestCodes = ['T4.3', 'T4.5', 'T9.1', 'T9.5', 'T9.6', 'T9.7', 'T9.8'];

        if (resData.error && !negativeTestCodes.includes(step.step_code)) {
          logicError = typeof resData.error === 'string' ? resData.error : JSON.stringify(resData.error);
        } else if (resData.success === false && !negativeTestCodes.includes(step.step_code)) {
          logicError = resData.message || 'İşlem başarısız döndü (success: false).';
        }

        // Nihai Karar
        if (logicError) {
          step.status = 'failed'
          step.errorMessage = logicError
        } else if (step.executedHttpCode === step.expected_http_code) {
          step.status = 'passed'
        } else {
          step.status = 'failed'
          step.errorMessage = `Beklenen HTTP ${step.expected_http_code}, dönen ${step.executedHttpCode}`
        }

      } catch (err) {
        step.duration = Date.now() - start
        step.executedHttpCode = err.response ? err.response.status : 500

        const errData = err.response ? err.response.data : null

        if (err.response && err.response.status === step.expected_http_code) {
          step.status = 'passed'
        } else {
          step.status = 'failed'
          if (errData && errData.error) {
            step.errorMessage = typeof errData.error === 'string' ? errData.error : JSON.stringify(errData.error)
          } else if (errData && errData.message) {
            step.errorMessage = errData.message
          } else {
            step.errorMessage = err.message || 'Bilinmeyen hata'
          }
        }
      }
    },

    async completeRun() {
      const durationMs = Date.now() - (this.runStartTime || Date.now())
      const passedCount = this.filteredSteps.filter(s => s.status === 'passed').length
      const failedCount = this.filteredSteps.filter(s => s.status === 'failed').length

      const payload = {
        run_id: this.currentRunId,
        customer_sk: this.$store.state.user?.customerInfo?.secret_key,
        total_steps: this.filteredSteps.length,
        passed_steps: passedCount,
        failed_steps: failedCount,
        duration_ms: durationMs,
        results: this.filteredSteps.map(s => ({
          code: s.step_code,
          title: s.title,
          status: s.status,
          http_code: s.executedHttpCode,
          duration: s.duration,
          error: s.errorMessage
        }))
      }

      try {
        if (this.currentRunId) {
          await this.$http.post('/manage/test-runs/complete', payload)
        }
      } catch (err) {
        console.error('Test sonuç kaydı güncellenemedi:', err)
      }

      this.fetchRuns()

      this.$bvToast.toast(`${this.selectedPhase} testi tamamlandı. ${passedCount} Başarılı, ${failedCount} Hata.`, {
        title: failedCount === 0 ? 'Tamamlandı' : 'Hatalar Var',
        variant: failedCount === 0 ? 'success' : 'danger',
        solid: true
      })
    },

    getStepBorderClass(status) {
      if (status === 'passed') return 'border-success bg-light-success'
      if (status === 'failed') return 'border-danger bg-light-danger'
      if (status === 'running') return 'border-primary'
      return 'border-light'
    },
    getStepAvatarVariant(status) {
      if (status === 'passed') return 'light-success'
      if (status === 'failed') return 'light-danger'
      if (status === 'running') return 'light-primary'
      return 'light-secondary'
    },
    getBadgeVariant(status) {
      if (status === 'passed') return 'light-success'
      if (status === 'failed') return 'light-danger'
      if (status === 'running') return 'light-primary'
      return 'light-secondary'
    },
    getStatusLabel(status) {
      if (status === 'passed') return 'Başarılı'
      if (status === 'failed') return 'Başarısız'
      if (status === 'running') return 'Çalışıyor'
      return 'Bekliyor'
    },
    getStatusIcon(status) {
      if (status === 'passed') return 'CheckCircleIcon'
      if (status === 'failed') return 'XCircleIcon'
      if (status === 'running') return 'LoaderIcon'
      return 'ClockIcon'
    }
  }
}
</script>

<style lang="scss" scoped>
.test-steps-timeline {
  .test-step-item {
    transition: all 0.2s ease-in-out;
  }
}
.font-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
</style>